const ArrowDownIconV2 = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2514_58752)">
        <path
          d="M15.2075 7.875L11 12.0733L6.7925 7.875L5.5 9.1675L11 14.6675L16.5 9.1675L15.2075 7.875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2514_58752">
          <rect width="22" height="22" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowDownIconV2;
